// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCache } from '../../../DataCache';
import { Resources } from '@shared/localizations/Resources';
import { getAccountTypeStr } from '@shared/utils/Account/AccountType';
import { InfoGroupEnum } from '@shared/utils/Enums/AccountDetailsEnum';
import { RulesSet } from '@shared/utils/Rules/RulesSet';
import { BaseAccountGroupController } from '../BaseControllers/BaseAccountGroupController';
import { RowItemDataNumberArray, RowItemDataStringArray } from '../../../cache/VerticalPanel/AccountDetails/RowItemData';
import { VerticalPanelColoringTypes } from '../../VerticalPanelColoringTypes';
import { GROUP } from '@shared/utils/Rules/AccountRules';
export class InfoGroupController extends BaseAccountGroupController {
    getGroupItemsTypes() {
        return [
            InfoGroupEnum.Owner,
            InfoGroupEnum.UserID,
            InfoGroupEnum.UserLogin,
            InfoGroupEnum.UserGroup,
            InfoGroupEnum.Email,
            InfoGroupEnum.Login,
            InfoGroupEnum.AccountType,
            InfoGroupEnum.LockedBy,
            InfoGroupEnum.AccountMode,
            InfoGroupEnum.ClientType,
            InfoGroupEnum.Status,
            InfoGroupEnum.TelephoneNumber,
            InfoGroupEnum.Asset,
            InfoGroupEnum.AssetDescription,
            InfoGroupEnum.AssetType
        ];
    }
    getDynamicItems() {
        return [];
    }
    getItemValue(type) {
        return new RowItemDataNumberArray(NaN);
    }
    getItemFormattedValue(type, key) {
        const curAccount = this.Account;
        const assetBalance = this.AssetBalance;
        switch (type) {
            case InfoGroupEnum.Login:
                return new RowItemDataStringArray(curAccount.FullAccString);
            case InfoGroupEnum.AccountType:
                return new RowItemDataStringArray(Resources.getResource('enum.AccountType.' + getAccountTypeStr(curAccount.AccountType)));
            case InfoGroupEnum.Asset:
                return new RowItemDataStringArray(assetBalance.Asset.Name);
            default:
                return new RowItemDataStringArray('');
        }
    }
    getItemNameKey(type) {
        switch (type) {
            case InfoGroupEnum.Login:
                return 'panel.accounts.Login';
            case InfoGroupEnum.AccountType:
                return 'panel.accounts.AccountType';
            case InfoGroupEnum.Asset:
                return 'panel.accounts.Asset';
        }
    }
    getItemRule(type) {
        switch (type) {
            case InfoGroupEnum.Owner:
                return 'FUNCTION_ACCOUNT_DETAILS_OWNER';
            case InfoGroupEnum.UserID:
                return 'FUNCTION_ACCOUNT_DETAILS_USER_ID';
            case InfoGroupEnum.UserLogin:
                return 'FUNCTION_ACCOUNT_DETAILS_USER_LOGIN';
            case InfoGroupEnum.UserGroup:
                return 'FUNCTION_ACCOUNT_DETAILS_USER_GROUP';
            case InfoGroupEnum.Email:
                return 'FUNCTION_ACCOUNT_DETAILS_EMAIL';
            case InfoGroupEnum.Login:
                return 'FUNCTION_ACCOUNT_DETAILS_ACCOUNT';
            case InfoGroupEnum.AccountType:
                return 'FUNCTION_ACCOUNT_DETAILS_ACCOUNT_TYPE';
            case InfoGroupEnum.AccountMode:
                return 'FUNCTION_ACCOUNT_DETAILS_ACCOUNT_MODE';
            case InfoGroupEnum.ClientType:
                return 'FUNCTION_ACCOUNT_DETAILS_TERMINAL_TYPE';
            case InfoGroupEnum.Status:
                return 'FUNCTION_ACCOUNT_DETAILS_STATUS';
            case InfoGroupEnum.TelephoneNumber:
                return 'FUNCTION_ACCOUNT_DETAILS_TELEPHONE';
            case InfoGroupEnum.Asset:
                return 'FUNCTION_ACCOUNT_DETAILS_ASSET';
            case InfoGroupEnum.AssetDescription:
                return 'FUNCTION_ACCOUNT_DETAILS_ASSET_DESCRIPTION';
            case InfoGroupEnum.AssetType:
                return 'FUNCTION_ACCOUNT_DETAILS_ASSET_TYPE';
            case InfoGroupEnum.LockedBy:
                return 'FUNCTION_ACCOUNT_DETAILS_LOCKED_BY';
            default:
                return null;
        }
    }
    getItemGroupRule() {
        return GROUP.INFO;
    }
    isHiddenItemRow(type) {
        if (super.isHiddenItemRow(type)) {
            return true;
        }
        if (DataCache.isAllowedForMyUser(RulesSet.FUNCTION_EXT_RISK)) {
            return true;
        }
        return true;
    }
    getColoringMethod(type) {
        return VerticalPanelColoringTypes.Default;
    }
}
